import { render, staticRenderFns } from "./CtaToAdv.vue?vue&type=template&id=4a646eae&scoped=true&"
import script from "./CtaToAdv.vue?vue&type=script&lang=js&"
export * from "./CtaToAdv.vue?vue&type=script&lang=js&"
import style0 from "./CtaToAdv.vue?vue&type=style&index=0&id=4a646eae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a646eae",
  null
  
)

export default component.exports